import Utils from '@/common/utils/utils';
import { updatePreviewCategoryListAtom } from '@/state/atom/chatBotPreview';
import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import { cloneDeep } from 'lodash';
import { useRecoilState } from 'recoil';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    let result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    result = result.map((item, index) => {
        item.order = index + 1;
        return item;
    });

    return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid * 2,
    // change background colour if dragging
    background: isDragging ? '#C7CAD1' : '#FFFFFF',

    // styles we need to apply on draggables
    ...draggableStyle
});

export default function CategoryChatBotComponent({
    onClickToggleCategorySetting,
    categoryList,
    setCategoryList,
    onClickDetailCategoryChatbot,
    onRemoveCategory,
    setIsEdited,
    setRemovedCategoryId
}) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const [previewCategoryList, setPreviewCategoryList] = useRecoilState(
        updatePreviewCategoryListAtom
    );
    const onDragEnd = result => {
        if (!result.destination) {
            return;
        }
        const cloneCategoryList = cloneDeep(categoryList);
        const items = reorder(cloneCategoryList, result.source.index, result.destination.index);
        let newCategoryList = sortPreviewCategory(items);
        setPreviewCategoryList([...newCategoryList]);
        setCategoryList(items);
        setIsEdited(true);
    };

    const sortPreviewCategory = items => {
        let clonePreviewCategoryList = cloneDeep(previewCategoryList);
        let newCategoryList = clonePreviewCategoryList.map(previewCategory => {
            const category = items.find(categoryItem => {
                return categoryItem.id === previewCategory.id;
            });

            if (!Utils.isEmptyObject(category)) {
                previewCategory.order = category.order;
            }
            return previewCategory;
        });
        newCategoryList = newCategoryList.filter(category => {
            return !Utils.isEmptyObject(category);
        });

        return newCategoryList;
    };

    return (
        <div className="setting-category">
            <div className="setting-index-listqa">
                <div>{tr('質問カテゴリ設定:')}</div>
                <img
                    src="/assets/image/add-formqa-chatbot.svg"
                    alt=""
                    onClick={() => onClickToggleCategorySetting(true)}
                />
            </div>
            {categoryList?.length > 0 ? (
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                className="list-form-qa-chatbot"
                            >
                                {categoryList.map((item, index) => (
                                    <Draggable key={item.id} draggableId={item.id} index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                className="item-qa-chatbot"
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}
                                            >
                                                <div
                                                    className="item-name-qa-chatbot"
                                                    onClick={() =>
                                                        onClickDetailCategoryChatbot(
                                                            item.id,
                                                            item.edit
                                                        )
                                                    }
                                                >
                                                    <OverFlowTooltipWithTabsMui
                                                        value={item.name}
                                                        className="item-name-category-detail"
                                                    />
                                                </div>
                                                <img
                                                    className="item-name-qa-chatbot"
                                                    src="/assets/image/remove-form-chatbot.svg"
                                                    alt="delete"
                                                    onClick={() => setRemovedCategoryId(item.id)}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            ) : (
                <>
                    <div className="list-form-qa-chatbot" style={{ display: 'flex' }}>
                        <div className="item-qa-chatbot">
                            <div className="item-name-qa-chatbot">
                                <p>{tr('データがありません。')}</p>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
